import { makeStyles } from "@material-ui/core/styles";

export const useFirstUseStyles = makeStyles({
  bodyText: { lineHeight: 1.2 },
  inlineIcon: { verticalAlign: `middle` }
});
